module.exports = __webpack_public_path__ + "static/media/model-network-view.5af6e211.jpg";